import { Label, TextInput } from "@adasupport/byron";
import React from "react";

import { Txt } from "components/Common";
import { NO_OP_FUNCTION } from "services/helpers";

import * as S from "./styles";

interface Props {
  outboundHostname: string;
  smtpPort: string;
  username: string;
}

export const AdaCredentialsSection = ({
  outboundHostname,
  smtpPort,
  username,
}: Props) => {
  return (
    <S.SectionGrid>
      <S.SectionNumber>2.</S.SectionNumber>
      <S.SectionContent>
        <Txt color="main" weight="semibold" size="small">
          Ada credentials
        </Txt>
        <Txt color="muted" size="small">
          Enter the values below into your Zendesk Admin Center, under the
          support addresses settings on the email channel page.
        </Txt>
        <S.FormGrid>
          <div>
            <Label>Outbound hostname</Label>
            <TextInput
              value={outboundHostname}
              isInvalid={false}
              isReadOnly={true}
              isDisabled={false}
              onChange={NO_OP_FUNCTION}
            />
          </div>
          <div>
            <Label>SMTP Port</Label>
            <TextInput
              value={smtpPort}
              isInvalid={false}
              isReadOnly={true}
              isDisabled={false}
              onChange={NO_OP_FUNCTION}
            />
          </div>
          <S.FullWidth>
            <Label>Username of this account</Label>
            <TextInput
              value={username}
              isInvalid={false}
              isReadOnly={true}
              isDisabled={false}
              onChange={NO_OP_FUNCTION}
            />
          </S.FullWidth>
          <S.FullWidth>
            <S.Description>
              Once generated, copy the password and store it somewhere safe.{" "}
              <S.Strong>The password will only be shown once.</S.Strong> If you
              generate a new password, you will need to update it in Zendesk.
            </S.Description>
          </S.FullWidth>
        </S.FormGrid>
      </S.SectionContent>
    </S.SectionGrid>
  );
};
